import { MobileApplicationAppConfig } from '../../types';

export const mobileApplicationAppConfig: MobileApplicationAppConfig = {
  androidStoreUrl: 'https://play.google.com/store/apps/details?id=com.bcf.letsbetmd',
  iosStoreUrl: 'https://apps.apple.com/us/app/letsbet-md/id6444439302'
};
